// Ответ PATCH /api/v1/invoices/:id → строка списка счетов (Invoices.vue).
//
// Сервер отдаёт сам счёт, где вычисляемые поля строки списка пустые (paid и client_name
// — атрибуты модели, в ответе PATCH они null): «оплачено» считается при загрузке списка
// по проведённым платежам, client_name — подпись клиента. Их переносим из прежней строки;
// подпись клиента — из параметра clientName, если клиента в правке сменили.
//
// Ответ 2xx БЕЗ тела — не успех. До api-фикса «Rollback до render» (27.09.2026)
// невалидный счёт (например, без клиента) отдавал пустой 204: axios считал его
// успехом, и запись поля в пустую строку роняла страницу (Rollbar, staging,
// «Cannot create property 'paid' on string ''»), а правка молча не сохранялась.
// Возврат null — сигнал вызывающему показать ошибку и не трогать список.
export function updatedInvoiceRow(response, previous, { clientName } = {}) {
  const data = response && response.data;
  if (!data || typeof data !== "object" || Array.isArray(data) || data.id == null) {
    return null;
  }
  return {
    ...data,
    paid: previous ? previous.paid : undefined,
    client_name: clientName !== undefined ? clientName : previous ? previous.client_name : undefined,
  };
}

// Подпись клиента в строке списка — ровно правило сервера (all_invoices в api
// invoices_controller): юрлицо — short_entity_name || id, физлицо — name && lastname ?
// «имя фамилия» : id. Проверки — на null/undefined, а не на «ложность»: в Ruby пустая
// строка истинна, и сервер для name "Пётр" + lastname "" отдаёт «Пётр », а не id.
// Иначе подпись после смены клиента расходилась бы с той, что придёт при перезагрузке.
// Поля берутся из this.clients — поиск клиентов (index_new_booking_page) отдаёт записи
// из БД целиком, short_entity_name там есть.
const present = (value) => value !== null && value !== undefined;

export function invoiceClientName(client) {
  if (!client) return null;
  if (client.entity) return present(client.short_entity_name) ? client.short_entity_name : client.id;
  return present(client.name) && present(client.lastname) ? `${client.name} ${client.lastname}` : client.id;
}
